<template>
	<div>
		<div class="item-box" :data-num="`${index+1}、`">
			<div class="item-title">{{item.title||'--'}}</div>
			<!-- 非专页 -->
			<div v-if="!item.detail" class="no-zhuanye">
				<div class="item-contern">
					<van-image v-if="item.indexPic" class="itemc-img" :src="item.indexPic" />
					{{item.description||'--'}}
				</div>
				<div class="foor-bot flex_c_m">
					<div class="foor-left">
						当前<b>{{item.num||'--'}}</b>票
					</div>
					<div class="foor-right">
						<van-button size="small" type="default" class="btn-green" @click="setVote(item)">投一票</van-button>
					</div>
				</div>
			</div>
			<!-- 是专页 -->
			<div v-if="item.detail" class="yes-zhuanye">
				<div class="item-contern">
					<div class="itemcimg-box">
						<van-image class="itemc-img" :src="item.indexPic" />
						<div class="img-per flex_c_m">{{item.num||'--'}}票</div>
					</div>
					{{item.description||'--'}}
				</div>
				<div class="foor-bot flex_c_m">
					<div class="foor-left flex_c_ri">
						<van-button size="small" type="default" class="btn-green" @click="setVote(item)">投一票</van-button>
					</div>
					<div class="foor-right flex_c_le">
						<van-button size="small" type="default" class="btn-border" :to="{path:'/votePageInfo',query:{id:item.id,voteCode:this.$route.query.voteCode}}">查看详情</van-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		setLocal,
		getLocal
	} from '@utils/tools.js'
		import {
		wxTools
	} from '@utils'
	export default {
		props: {
			hanzhuanye: {
				type: Boolean,
				default: false
			},
			index: {
				type: Number,
				default: 0
			},
			item: {
				type: Object,
				default: () => ({})
			},
			info: {
				type: Object,
				default: () => ({})
			}
		},
		data() {
			return {

			}
		},
		methods: {
			isDuringDate() {
				var curDate = new Date().getTime()
					
				if (curDate < this.info.voteStartTimestamp) {
					this.$dialog.alert({
						title: '温馨提示',
						message: '活动未开始，请先关注公众号！'
						// message: `投票开始时间还未到！将于 `+this.info.voteStartTime+` 开始投票！`,
					}).then(() => {
						
					});
					return false;
				}else if(curDate > this.info.voteEndTimestamp){
					this.$dialog.alert({
						title: '温馨提示',
						message: `投票时间已经于`+this.info.voteEndTime+' 结束！',
					}).then(() => {
						
					});
					return false;
				}
				return true;
			},
			// 投一票
			setVote(item) {
				if (!this.isDuringDate()) {
					return
				}
				let uinfo = getLocal({
					key: 'userInfo',
					parse: true
				});
				let wxinfo = uinfo ? uinfo.wx : {};
				let wxUserInfo = uinfo && uinfo.user ? uinfo.user : {};
				let {openid = undefined} = wxinfo;
				let userId = wxUserInfo.id;
				let param = {
					openid: openid,
					userId: userId,
					voteId: item.voteId,
					voteItemId: item.id,
				}
				this.$api.lineVote.setVote(param, res => {
					if (res.data) {
						this.$toast('投票成功');
						this.$emit('onSuccess', {
							num: res.data,
							index: this.index
						});
						return
					}
					this.$toast(res.msg);
				}, err => {
					// if (err.code == 501) {
					// 	// this.$toast().clear()
					// 	this.$dialog.alert({
					// 		title: '温馨提示',
					// 		message: '今日投票已达上限！' // err.msg,
					// 	}).then(() => {
					// 		console.log(window.location.href)
					// 		// const url = `http://www.cd5i.com/registered?voteCode=${this.$route.query.voteCode}`
					// 		// new wxTools().getCode({
					// 		//	securityUrl: url,
					// 			// state: this.voteCode
					// 		// })
					// 		// this.$router.push({
					// 		// 	path: '/registered',
					// 		// 	query: {
					// 		// 		voteId: item.voteId,
					// 		// 		voteCode:this.$route.query.voteCode
					// 		// 	}
					// 		// })
					// 	});
					// }
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.item-box {
		background-color: #fff;
		padding: 15px;
		padding-left: 40px;
		margin-bottom: 10px;
		position: relative;

		&::before {
			content: attr(data-num);
			font-size: 16px;
			color: #333;
			position: absolute;
			left: 15px;
			top: 15px;
		}

		.item-title {
			font-size: 16px;
			color: #333;
			margin-bottom: 10px;
		}

		.item-contern {
			font-size: 14px;
			color: #666;

			.itemc-img {
				height: 200px;
				width: 100%;
			}
		}

		.foor-bot {
			margin-top: 10px;

			.foor-left {
				width: 50%;
				font-size: 14px;
				color: #666;

				b {
					color: #38C7B4;
				}
			}

			.foor-right {
				text-align: right;
				width: 50%;
			}
		}

		.yes-zhuanye {
			.itemcimg-box {
				position: relative;
				height: 200px;

				.img-per {
					width: 110px;
					height: 32px;
					background: url('~@assets/images/icon/baiobiaobiao.png') no-repeat 10px center;
					background-size: 19px 19px;
					background-color: rgba(56, 199, 180, 0.9);
					border-radius: 0px 5px 0px 0px;
					font-size: 14px;
					color: #fff;
					position: absolute;
					bottom: 0;
					left: 0;
				}
			}

			.foor-left {
				padding-right: 10px;
			}
		}
	}
</style>
